<template>
    <div class="cookie-bar" :class="{ 'out': !isVisible, 'border-top bg-white': isVisible, 'fixed-bottom': !isShopBuilder || false }">
        <div class="container-max" v-if="isVisible">
            <div class="row py-3" v-show="!isExpanded" :class="classes" :style="styles">
                <div class="col-12">

                    <div class="cookie-bar__headline">
                        {{ $translate("ODKleinMore::Template.cookieBarHeadline") }}
                    </div>

                    <div class="cookie-bar__text" v-html="$translate('ODKleinMore::Template.cookieBarText')"></div>

                </div>
                <div class="col-12">
					<div class="row">
						<div class="col-12 col-lg-6">
							<button class="btn btn-primary btn-block btn-appearance" @click="acceptAll(); close()">  {{ $translate("ODKleinMore::Template.cookieBarButton1") }}</button>
						</div>
						<div class="col-12 col-lg-6 mt-2 mt-lg-0">
							<button
								v-if="showRejectAll"
								class="btn btn-primary btn-block btn-appearance"
								@click="denyAll(); close()"
								data-testing="cookie-bar-deny-all">
								{{ $translate("Ceres::Template.cookieBarDenyAll") }}
							</button>
						</div>
<!--						<div class="col-12 col-lg-4">-->
<!--							<button class="btn btn-primary btn-block btn-appearance" @click="storeConsents(); close()">{{ $translate("ODKleinMore::Template.cookieBarButton3") }}</button>-->
<!--						</div>-->

					</div>

					<button class="cookie-bar__button--2" @click.prevent.stop="isExpanded=true">{{ $translate("ODKleinMore::Template.cookieBarButton2") }}</button>

                </div>

                <div class="col-12 cookie-bar__image">
                    <img src="https://cdn02.plentymarkets.com/0fzvjq1iz403/frontend/KM_Logo.png" alt="Logo">
                    <p class="cookie-bar__info" v-html="text"></p>
                </div>



            </div>
            <div class="row py-3" v-if="isExpanded" :class="classes" :style="styles">
                <div class="col-12">
                    <a href="#" class="text-primary text-appearance d-inline-block mb-3" @click.prevent.stop="isExpanded = false">{{ $translate("Ceres::Template.cookieBarBack") }}</a>
                </div>

                <div class="col-12 mb-3">
                    <privacy-settings :consent-groups="consentGroups"></privacy-settings>
                </div>

                <div class="col-12">
                    <button class="btn btn-block btn-primary btn-appearance" @click="acceptAll(); close()">{{ $translate("ODKleinMore::Template.cookieBarButton1") }}</button>
                </div>

                <div class="col-12">
					<button
						v-if="showRejectAll"
						class="btn btn-primary btn-block btn-appearance mt-2"
						@click="denyAll(); close()"
						data-testing="cookie-bar-deny-all">
						{{ $translate("Ceres::Template.cookieBarDenyAll") }}
					</button>
				</div>
                <div class="col-12 ">
                    <button class="cookie-bar__button--2" @click="storeConsents(); close()">{{ $translate("ODKleinMore::Template.cookieBarButton3") }}</button>
                </div>
            </div>
        </div>

        <div v-else>
            <button class="btn btn-primary btn-appearance" @click.prevent.stop="isCollapsed = false">
                <span class="d-none d-sm-inline-block">{{ $translate("Ceres::Template.cookieBarPrivacySettings") }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapMutations } from "vuex";
import { ComponentIdMixin } from "ceres/app/mixins/componentId.mixin";

export default {
    props:
        {
            styles: String,
            classes: String,
            consentGroups: Object,
			showRejectAll: {
				type: Boolean,
				default: true
			},
        },

    mixins: [ComponentIdMixin], // Experimental mixin, may be removed in the future.

    data()
    {
        return {
            isCollapsed: true,
            isExpanded: false
        };
    },

    computed:
        {
            isVisible()
            {
                return App.isShopBuilder || !this.$store.state.consents.hasResponse || !this.isCollapsed;
            },

            isShopBuilder()
            {
                return App.isShopBuilder;
            },

            text()
            {
                const links = {
                    gtc: "<a class=\"text-appearance\" href=\"" + App.urls.gtc + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutGtc") + "</a>",
                    cancellation: "<a class=\"text-appearance\" href=\"" + App.urls.cancellationRights + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutCancellationRight", {"hyphen": "&shy;"}) + "</a>",
                    policy: "<a class=\"text-appearance\" href=\"" + App.urls.privacyPolicy + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutPrivacyPolicy", {"hyphen": "&shy;"}) + "</a>",
                    legal: "<a class=\"text-appearance\" href=\"" + App.urls.legalDisclosure + "\" target=\"_blank\">" + this.$translate('Ceres::Template.footerLegalDisclosure') + "</a>"
                };

                return this.$translate("Ceres::Template.cookieBarHintText", links);
            }
        },

    methods:
        {
            ...mapMutations([
                "storeConsents",
                "acceptAll",
				"denyAll"
			]),

            close()
            {
                this.isCollapsed = true;
                this.isExpanded = false;
            },

			open()
			{
				this.isCollapsed = false;
			},

            isConsented(groupKey)
            {
                return this.$store.getters.isConsented(groupKey + ".*");
            },

            toggleConsent(groupKey)
            {
                this.$store.commit("toggleConsent", groupKey + ".*");
            }
        }
}
</script>
